import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Named z-index steps from tailwind.config.ts, so a caller's z-30 or z-[10001] replaces z-dropdown.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: { z: [{ z: ["sticky", "dropdown", "overlay", "modal", "toast"] }] },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
